import { filter, map } from 'ramda'

import type { utils_salesAssociate$data } from '../__generated__/utils_salesAssociate.graphql'
import type { Lists, PositionsListItem } from '..'

export const itemsToAdd = (
  listsSalesAssociates: utils_salesAssociate$data[],
  activeSalesAssocitesIds: string[]
): string[] => {
  const listsSalesAssociatesIds = listsSalesAssociates.map((item) => item.id)
  const salesAssociatesToAdd = activeSalesAssocitesIds.filter(
    (id) => !listsSalesAssociatesIds.includes(id)
  )

  return salesAssociatesToAdd
}

export const itemsToRemove = (
  listsSalesAssociates: utils_salesAssociate$data[],
  activeSalesAssocitesIds: string[]
): string[] => {
  const salesAssociatesIds = activeSalesAssocitesIds

  const salesAssociatesToRemove = listsSalesAssociates.filter(
    (item) => !salesAssociatesIds.includes(item.id)
  )

  return salesAssociatesToRemove.map((item) => item.id)
}

export const findPositionListsAndSalesAssociatesDivergences = (
  positionsLists: Lists,
  activeSalesAssociatesIds: string[]
) => {
  const { inServiceList, outOfStoreList, waitingList } = positionsLists

  const listsSalesAssociates = [
    ...inServiceList.map((item) => item.salesAssociate),
    ...waitingList.map((item) => item.salesAssociate),
    ...outOfStoreList.map((item) => item.salesAssociate),
  ]

  const salesAssociatesToAddIds = itemsToAdd(
    listsSalesAssociates,
    activeSalesAssociatesIds
  )

  const salesAssociatesToRemoveIds = itemsToRemove(
    listsSalesAssociates,
    activeSalesAssociatesIds
  )

  return {
    salesAssociatesToAddIds,
    salesAssociatesToRemoveIds,
  }
}

export const findSalesAssociatesOutOfStore = (
  positionsLists: Lists,
  ids: string[]
): string[] => {
  const getSalesAssociateIds = map(
    (item: PositionsListItem) => item.salesAssociate.id
  )

  const filterItems = filter((item: PositionsListItem) =>
    ids.includes(item.salesAssociate.id)
  )

  const outOfStoreIds = getSalesAssociateIds(
    filterItems(positionsLists.outOfStoreList)
  )

  return outOfStoreIds
}
